export default {
  rates: {
    title: 'Tarifas del proveedor',
    addRate: 'Añadir Tarifa',
    duplicateRate: 'Duplicar Tarifa',
    editRate: 'Editar Tarifa',
    removeRate: 'Eliminar Tarifa',
    list: 'Lista de tarifas',
    rate: 'Tarifa',
    minPax: 'Pax Mínimo',
    maxPax: 'Pax Máximo',
    individualRate: 'Tarifa Individual',
    roomingRate: 'Tarifa Rooming',
    supplement: 'Suplemento',
    groupType: 'Tipo de grupo',
    individual: 'Individual',
    rooming: 'Rooming',
    supplierResource: 'Recurso del proveedor',
    netPrice: 'Neto',
    commission: 'Comisión',
    grossPrice: 'Bruto',
    markToPay: 'Pago a cuenta',
    yes: 'Sí',
    no: 'No',
    markup: 'Margen',
    vat: 'IVA',
    isIncludedVat: 'IVA incluido',
    roomPriceType: 'Tipo de precio de la habitación',
    block: 'Bloque',
    bookingForm: 'Formulario de reserva',
    status: 'Estado',
    actions: 'Acciones',
    pax: 'Pasajero | Pasajeros',
    roomingPlaceholder: '1 individual, 2 doble...',
    vatRate: 'Tasa de IVA',
    addConcept: 'Añadir Concepto',
    commissionable: 'Comisionable',
    commissionRate: 'Tasa de comisión',
    typeNoOptions: 'No hay tipos disponibles',
    categoryNoOptions: 'No hay categorías disponibles',
    product: 'Producto',
    type: 'Tipo',
    category: 'Categoría',
    initDate: 'Fecha de inicio',
    endDate: 'Fecha final',
    price: 'Precio',
    removeTitle: 'Eliminar tarifa',
    singleRate: 'Duplicarás la siguiente tarifa',
    blockRate: 'Duplicarás el siguiente bloque',
    removeText: "¿Seguro que quieres borrar la tarifa del producto '{product}'? si la borras, no podrás recuperarla",
  },
  portal: {
    title: 'Portal de Proveedores',
    welcomeMessage: 'Gestione sus reservas y vea los próximos horarios',
    noBookings: 'No se han encontrado reservas',
    noBookingsSub: 'No hay reservas que mostrar para el periodo seleccionado.',
    caseNumber: 'Caso #',
    client: 'Cliente',
    firstName: 'Nombre',
    lastName: 'Apellido',
    clientPhone: 'Teléfono',
    clientEmail: 'Email',
    clientAddress: 'Dirección del Cliente',
    clientObservations: 'Observaciones del Cliente',
    clientDetails: 'Detalles del Cliente',
    checkIn: 'Entrada',
    checkOut: 'Salida',
    nights: 'noches',
    supplierName: 'Proveedor',
    location: 'Ubicación',
    roomType: 'Tipo de Habitación',
    dates: 'Fechas',
    resource: 'Recurso',
    details: 'Detalles',
    price: 'Precio',
    total: 'Total',
    status: 'Estado',
    bookingStatus: 'Reserva',
    paymentStatus: 'Pago',
    invoiceStatus: 'Factura',
    quantity: 'Cant',
    pax: 'Pax',
    upcoming: 'Próximas',
    past: 'Pasadas',
    searchLabel: 'Cliente / Nombre / Número del Caso',
    searchPlaceholder: 'Buscar por cliente, nombre o número del caso...',
    clearFilters: 'Limpiar filtros',
    clientTooltip: 'Los detalles del cliente serán visibles 48 horas antes de la entrada',
    priceTooltip: 'Haga clic en el icono del lápiz para introducir su precio',
    editPriceTooltip: 'Editar su precio',
    caseNumberTooltip: 'Número de referencia de reserva interna',
  },
  sendPortalLink: 'Enviar enlace de acceso al portal',
  sendPortalLinkConfirmTitle: 'Enviar enlace al portal',
  sendPortalLinkConfirmText: '¿Está seguro de que desea enviar el enlace de acceso al portal a "{supplier}"?',
  sendPortalLinkSuccess: 'Correo electrónico enviado correctamente',
  sendPortalLinkError: 'No se pudo enviar el correo electrónico',
  portalLoginLinkSection: 'Acceso al Portal de Proveedores',
  portalLoginLinkDescription: 'Envíe un correo electrónico al proveedor con el enlace de acceso a nuestro Portal de Proveedores.',
};
